import { useQuery } from '@tanstack/vue-query';
import { computed, unref } from '@vue/composition-api';
import type { MaybeRef } from '@tanstack/vue-query/build/lib/types';
import { DashboardService } from '../../api/dashboard/services/dashboard.service';
import { dashboardKeys } from './dashboard-key-factory';

export const useDashboardActivities = (showAll: MaybeRef<boolean>) =>
  useQuery({
    queryKey: computed(() => dashboardKeys.activityList(unref(showAll))),
    queryFn: () => DashboardService.getActivity({ showAll: unref(showAll) }),
  });
